import React from 'react';
import { Collapse, Table } from 'reactstrap';
import Isbn from './Isbn';
import ButtonAction from './ButtonAction';
import HelpPopover from './HelpPopover';
import { ISBN_TYPES, ISBN_FIELDS } from '../constants/Fixtures';
import { validateISBN } from '../helpers/Validations';
import * as warnings from '../constants/ValidationWarnings';

export default class IsbnList extends React.PureComponent {
  getIsbns() {
    return this.props.isbns || [];
  }

  isbnForType = isbnType => this.getIsbns().find(isbn => isbn.category === isbnType)

  addIsbn = (category, number) => {
    this.props.create({
      category,
      number,
    });
  }

  isbnList = () => ISBN_TYPES.map((isbnType) => {
    const isbnData = this.isbnForType(isbnType.value);
    let isbn;
    if (isbnData) {
      isbn = (<Isbn
        key={isbnData.number}
        id={isbnData.id}
        category={isbnData.category}
        number={isbnData.number}
        destroy={this.props.destroy}
        update={this.props.update}
      />);
    } else {
      isbn = (<Isbn
        key={`isbn-${isbnType.label}`}
        category={isbnType.label}
        destroy={this.props.destroy}
        update={(id, itemRef, number) => {
          this.addIsbn(isbnType.value, number);
        }}
      />);
    }
    return isbn;
  })

  render() {
    return (<div className="section-list" id='isbn-list'>
      {this.props.noHead ? null :
      <div className="section-header">
        <h2>ISBNs</h2>
        <div className="float-md-end">
          <HelpPopover
            size="sm"
            name="isbn-description"
            placement={'left'}
            title="ISBNs in the Digital Hub"
          >
            To add or update a specific ISBN type, click “empty” or the existing ISBN entry and enter the new number. When producing an ebook, the Digital Hub will use ISBNs with the following priorities:
            <ul style={{ marginBottom: '0' }}>
              <li>
                ePub: the Hub will check for an ePub ISBN, then a print ISBN.
              </li>
            </ul>
            If there is no ISBN, a placeholder will be added.
          </HelpPopover>
        </div>
      </div>}
      <Table className="section-table" responsive hover>
        <tbody>
          {this.isbnList()}
        </tbody>
      </Table>
    </div>);
  }
}
